module.exports = __webpack_public_path__ + "static/media/PM43.c5fd49d8.JPG";